
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { uiChatReducerActionTypes } from './uiChatTypes';
import { uiChatApiResponseError, uiChatApiResponseSuccess } from './uiChatActions';
import { showErrorNotification, showSuccessNotification } from "../../helpers/NotificationContext";
import { getSystemResponseApi, sendApproveEntryApi } from 'src/api/uiChat';
import { sendIdentityDocumentApi } from 'src/api/uiChat';
import { getInitialStateApi } from 'src/api/uiChat';
import { sendManuallyUpdatedEntryApi } from 'src/api/uiChat';
import { deleteIdentityDocumentApi } from 'src/api/uiChat';

function* getSystemResponseSaga(action: any) {
    try {
        console.log("[getSystemResponseSaga] action.payload", action.payload);

        const { file, transcript, entry_json , detected_language,  time_difference,   previous_agent_log_id, page } = action.payload;

        // const transcript = action.payload;
        console.log("sending transcript to api:", transcript);
        console.log("sending entry_json to api:", entry_json);
        const response = yield call(getSystemResponseApi, { file, transcript, entry_json ,detected_language, time_difference,  previous_agent_log_id, page});
        console.log("Backend response from getSystemResponseApi: ", response);
        yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.GET_SYSTEM_RESPONSE, response));
        showSuccessNotification(`🚀 Booking details fetched successfully!`);

    } catch (error: any) {
        console.error("Saga error fetching booking details:", error.message);
        yield put(uiChatApiResponseError(uiChatReducerActionTypes.GET_SYSTEM_RESPONSE, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}

function* sendApproveEntrySaga(action: any) {
    try {
        console.log("[sendApproveEntrySaga] action.payload", action.payload);

        const transcript = action.payload;
        console.log("sendApproveEntrySaga sending transcript to api:", transcript);
        const response = yield call(sendApproveEntryApi, transcript);
        console.log("Backend response from sendApproveEntrySaga: ", response);

        // Prefer top-level isSuccess; if absent, fallback to nested one.
        const isSuccess =
            response?.isSuccess ??
            response?.approved_booking?.isSuccess ??
            false; // default to false so we don't accidentally mark failure as success

        if (!isSuccess) {
            // ❌ Error path: dispatch error with the WHOLE payload and show error toast
            console.log("Backend response from sendApproveEntrySaga isSuccess false case triggre: ", response);
            yield put(
                uiChatApiResponseError(
                    uiChatReducerActionTypes.SEND_APPROVED_ENTRY,
                    response // send the entire response object
                )
            );

            return
        } else {
            console.log("[sendApproveEntrySaga]isSuccess case triggre");


            yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SEND_APPROVED_ENTRY, response));
            showSuccessNotification(`🚀 Booking details fetched successfully!`);
        }

    } catch (error: any) {
        console.error(" sendApproveEntrySaga Saga error fetching booking details:", error.message);
        yield put(uiChatApiResponseError(uiChatReducerActionTypes.SEND_APPROVED_ENTRY, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}


function* sendIdentityDocumentSaga(action: any) {
    try {
        console.log("[sendIdentityDocumentSaga] action.payload", action.payload);

        const { front, back } = action.payload as { front: File, back?: File };
        const response = yield call(sendIdentityDocumentApi, { front: front, back: back }); // 👈 fix
        console.log("Backend response from sendIdentityDocumentApi: ", response);
        if (response.error) {
            console.log("response error case triggeerd");
            yield put(uiChatApiResponseError(uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT, response.response.message));

            showErrorNotification("Execution failed: " + response.response.message);
        } else {
            yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT, response));
            showSuccessNotification(`🚀 Booking details fetched successfully!`);
        }

    } catch (error: any) {
        console.error("Saga error fetching booking details:", error.message);
        yield put(uiChatApiResponseError(uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}


function* deleteIdentityDocumentSaga(action: any) {
    try {
        console.log("[deleteIdentityDocumentSaga] action.payload", action.payload);

        const { image_path, docType, guest } = action.payload;

        // Call API to delete document
        const response = yield call(deleteIdentityDocumentApi, { image_path, docType, guest });
        console.log("Backend response from deleteIdentityDocumentApi: ", response);

        if (response.error) {
            console.log("Delete document API error case triggered");
            yield put(
                uiChatApiResponseError(
                    uiChatReducerActionTypes.DELETE_IDENTITY_DOCUMENT,
                    response.response?.message || "Failed to delete document"
                )
            );
            showErrorNotification("Deletion failed: " + (response.response?.message || ""));
        } else {
            yield put(
                uiChatApiResponseSuccess(
                    uiChatReducerActionTypes.DELETE_IDENTITY_DOCUMENT,
                    {
                        ...response,          // API response (success, message, deletedPath)
                        ...action.payload,    // original payload (guest, docType, image_path)
                    }
                )
            );
            showSuccessNotification(`🗑️ Document deleted successfully!`);
        }

    } catch (error: any) {
        console.error("Saga error deleting document:", error.message);
        yield put(
            uiChatApiResponseError(uiChatReducerActionTypes.DELETE_IDENTITY_DOCUMENT, error.message)
        );
        showErrorNotification("Deletion failed: " + error.message);
    }
}



// --- your existing sagas (getSystemResponseSaga, sendApproveEntrySaga, sendIdentityDocumentSaga) remain ---

function readFileAsText(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = () => resolve(fr.result as string);
        fr.onerror = () => reject(fr.error || new Error("Failed to read file"));
        fr.readAsText(file, "utf-8");
    });
}



// --- NEW: Load initial state from JSON file
// --- NEW: Load initial state from JSON file
// function* loadInitialStateFromFileSaga(action: any) {
//   try {
//     console.log("[loadInitialStateFromFileSaga] action.payload", action.payload);
//     const { file } = action.payload as { file: File };
//     if (!file) throw new Error("File not provided");

//     const text: string = yield call(readFileAsText, file);

//     let parsed: any = null;
//     try {
//       parsed = JSON.parse(text);
//     } catch (e) {
//       throw new Error("Invalid JSON in state file");
//     }

//     // Optional sanity checks (keep lightweight)
//     if (parsed && typeof parsed === "object") {
//       // pass-through; reducer will pick allowed keys
//     } else {
//       throw new Error("Parsed state is not an object");
//     }

//     yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE, parsed));
//     showSuccessNotification("✅ UI state loaded from file");
//   } catch (error: any) {
//     console.error("Saga error loading state from file:", error.message);
//     yield put(uiChatApiResponseError(uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE, error.message));
//     showErrorNotification("State load failed: " + error.message);
//   }
// }


// --- NEW: Save current state to JSON file (download)
function triggerBrowserDownload(filename: string, content: string) {
    const blob = new Blob([content], { type: "application/json;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }, 0);
}

function* saveStateToFileSaga(action: any) {
    try {
        const filename = (action.payload?.filename as string) || `ui-state-${Date.now()}.json`;

        // Select current UI slice (adjust selector to your store shape)
        const uiState = yield select((state: any) => state.uiChat);

        // Only persist whitelisted keys (same as reducer merge)
        const payload = {
            userUtterance: uiState.userUtterance ?? null,
            intent: uiState.intent ?? null,
            uiComponent: uiState.uiComponent ?? null,
            agentLogId: uiState.agentLogId ?? null,
            guests: Array.isArray(uiState.guests) ? uiState.guests : [],
            missingFields: Array.isArray(uiState.missingFields) ? uiState.missingFields : [],
            approvalSuccess: !!uiState.approvalSuccess,
            history: Array.isArray(uiState.history) ? uiState.history : [],
        };

        const json = JSON.stringify(payload, null, 2);
        yield call(triggerBrowserDownload, filename, json);

        yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SAVE_STATE_TO_FILE, { ok: true, filename }));
        showSuccessNotification(`💾 State saved as ${filename}`);
    } catch (error: any) {
        console.error("Saga error saving state to file:", error.message);
        yield put(uiChatApiResponseError(uiChatReducerActionTypes.SAVE_STATE_TO_FILE, error.message));
        showErrorNotification("State save failed: " + error.message);
    }
}



function* loadInitialStateFromFileSaga(action: any) {
    try {
        console.log("[sendApproveEntrySaga] action.payload", action.payload);

        // const transcript = action.payload;
        // console.log("sendApproveEntrySaga sending transcript to api:", transcript);
        const response = yield call(getInitialStateApi);
        console.log("Backend response from sendApproveEntrySaga: ", response);
        yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE, response.data));
        // yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SEND_APPROVED_ENTRY, response));
        showSuccessNotification("✅ UI state loaded from file");

    } catch (error: any) {
        console.error("Saga error loading state from file:", error.message);
        yield put(uiChatApiResponseError(uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE, error.message));
        showErrorNotification("State load failed: " + error.message);
    }
}





function* sendManuallyUpdatedEntrySaga(action: any) {
    try {
        console.log("[sendManuallyUpdatedEntrySaga] action.payload", action.payload);

        const transcript = action.payload;
        console.log("sendManuallyUpdatedEntrySaga sending to api:", transcript);
        const response = yield call(sendManuallyUpdatedEntryApi, transcript);


        if (response.error) {

            console.log("response error case triggeerd");
            console.log("error case sendManuallyUpdatedEntrySaga: ", response);
            yield put(uiChatApiResponseError(uiChatReducerActionTypes.SEND_MANUALLY_UPDATED_ENTRY, response.response.update_message));

            showErrorNotification("Execution failed: " + response.response.update_message);
        } else {
            console.log("Backend response from sendManuallyUpdatedEntrySaga: ", response);
            yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SEND_MANUALLY_UPDATED_ENTRY, response));
            showSuccessNotification(`🚀 Booking details fetched successfully!`);
        }

    } catch (error: any) {
        console.error(" sendManuallyUpdatedEntrySaga Saga error fetching booking details:", error.message);
        yield put(uiChatApiResponseError(uiChatReducerActionTypes.SEND_MANUALLY_UPDATED_ENTRY, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}


export default function* uiChatSaga() {
    yield takeLatest(uiChatReducerActionTypes.GET_SYSTEM_RESPONSE, getSystemResponseSaga);
    yield takeLatest(uiChatReducerActionTypes.SEND_APPROVED_ENTRY, sendApproveEntrySaga);
    yield takeLatest(uiChatReducerActionTypes.SEND_IDENTITY_DOCUMENT, sendIdentityDocumentSaga);
    yield takeLatest(uiChatReducerActionTypes.DELETE_IDENTITY_DOCUMENT, deleteIdentityDocumentSaga);

    // NEW:
    yield takeLatest(uiChatReducerActionTypes.LOAD_INITIAL_STATE_FROM_FILE, loadInitialStateFromFileSaga);
    yield takeLatest(uiChatReducerActionTypes.SAVE_STATE_TO_FILE, saveStateToFileSaga);

    yield takeLatest(uiChatReducerActionTypes.SEND_MANUALLY_UPDATED_ENTRY, sendManuallyUpdatedEntrySaga);


}